import React from 'react';

const Logo = () => {
    return (
        <img src={require('../../../assets/MTrading.png')} width={154} height={22} draggable={false}/>
    );
};

export default Logo;